@if (loadingAccessTemplates) {
  <div arpSurfaceErrorHost="update-access-dialog" #loadError="surfaceErrorHost">
    @if (loadError.error) {
      <!-- This branch replaces the whole dialog body, so it has to carry its own way out. -->
      <div class="modal-header">
        <h3 class="panel-title">Update access</h3>
        <button
          type="button"
          class="modal-close-btn"
          (click)="onCancel()"
          pTooltip="Close"
          tooltipPosition="left"
          aria-label="Close"
        >
          <svg lucideX></svg>
        </button>
      </div>
      <arp-error-block class="dialog-error" [error]="loadError.error"></arp-error-block>
      <div class="modal-footer">
        <button type="button" class="arpio-secondary-button" (click)="onCancel()">Close</button>
      </div>
    } @else {
      <h3 class="panel-title">
        <svg lucideLoaderCircle class="lucide-spin"></svg> Loading updated access templates...
      </h3>
    }
  </div>
} @else {
  <div
    class="flex-left-column light-control-host"
    arpSurfaceErrorHost="update-access-dialog"
    #dialogError="surfaceErrorHost"
  >
    <div class="modal-header">
      <h3 class="panel-title">Let's get you updated.</h3>
      <button
        type="button"
        class="modal-close-btn"
        (click)="onCancel()"
        pTooltip="Close"
        tooltipPosition="left"
        aria-label="Close"
      >
        <svg lucideX></svg>
      </button>
    </div>
    @if (applicationType === 'aws') {
      <div class="modal-subtitle">
        We've enhanced {{ uiService.productName }}, but to get this new functionality you'll need to update the
        CloudFormation stacks that grant {{ uiService.productName }} limited access to your AWS environment.
      </div>
      <aws-account-access-view
        class="margin-top"
        [state]="sourceAccessService.state"
        [stackName]="sourceAccessService.stack"
        [accessType]="Scope.SOURCE"
        [templateUrl]="sourceAccessTemplate"
        [awsAccountId]="sourceAccountId"
        [region]="sourceRegion"
        [completedTestCount]="sourceAccessService.tests"
        (buttonClicked)="sourceAccessService.validateAccess()"
      >
      </aws-account-access-view>
      <aws-account-access-view
        class="margin-top"
        [state]="targetAccessService.state"
        [stackName]="targetAccessService.stack"
        [accessType]="Scope.TARGET"
        [templateUrl]="targetAccessTemplate"
        [awsAccountId]="targetAccountId"
        [region]="targetRegion"
        [completedTestCount]="targetAccessService.tests"
        (buttonClicked)="targetAccessService.validateAccess()"
      >
      </aws-account-access-view>
      @if (stackSetsEnabled) {
        <stacksets-instructions
          class="margin-top"
          [sourceStackSetTemplateUrl]="sourceStackSetTemplateUrl"
          [targetStackSetTemplateUrl]="targetStackSetTemplateUrl"
          [sourceTemplateBucket]="sourceTemplateBucket"
          [sourceTemplateKey]="sourceTemplateKey"
          [targetTemplateBucket]="targetTemplateBucket"
          [targetTemplateKey]="targetTemplateKey"
          [sourceAccountId]="sourceAccountId"
          [sourceRegion]="sourceRegion"
          [targetAccountId]="targetAccountId"
          [targetRegion]="targetRegion"
          [sourceStackName]="sourceAccessService?.stack"
          [targetStackName]="targetAccessService?.stack"
          [sourceManagedByStackSet]="sourceAccessService?.managedByStackSet"
          [targetManagedByStackSet]="targetAccessService?.managedByStackSet"
          [sourceAccessState]="sourceAccessService?.state"
          [targetAccessState]="targetAccessService?.state"
          [testingSource]="isTestingSourceAccess"
          [testingTarget]="isTestingTargetAccess"
          [arpioAccountId]="accountId"
          [regenerationJobId]="regenerationJobId"
          (testAccess)="onTestAccess($event)"
        ></stacksets-instructions>
      }
    }
    @if (applicationType === 'azure') {
      <div class="modal-subtitle">
        We've enhanced {{ uiService.productName }}, but to get this new functionality you'll need to update the
        Deployment Stacks that grant {{ uiService.productName }} limited access to your Azure environment.
      </div>
      <azure-access-view
        class="margin-top"
        [state]="targetAccessService.state"
        [accessType]="Scope.TARGET"
        [installCommand]="targetInstallCommand"
        [subscriptionId]="targetAccountId"
        [region]="targetRegion"
        [completedTestCount]="targetAccessService.tests"
        (buttonClicked)="targetAccessService.validateAccess()"
      >
      </azure-access-view>
      <azure-access-view
        class="margin-top"
        [state]="sourceAccessService.state"
        [accessType]="Scope.SOURCE"
        [installCommand]="sourceInstallCommand"
        [subscriptionId]="sourceAccountId"
        [region]="sourceRegion"
        [completedTestCount]="sourceAccessService.tests"
        (buttonClicked)="sourceAccessService.validateAccess()"
      >
      </azure-access-view>
    }
    @if (dialogError.error) {
      <arp-error-block
        class="dialog-error"
        [error]="dialogError.error"
        [dismissible]="true"
        (dismissed)="dialogError.clear()"
      ></arp-error-block>
    }

    <div class="modal-footer">
      @if (dialogError.error?.blockedReason) {
        <span class="modal-footer-hint">{{ dialogError.error.blockedReason }}</span>
      }

      <button type="button" class="arpio-secondary-button" (click)="onCancel()">Cancel</button>
      <button
        type="button"
        class="arpio-button"
        [disabled]="!accessChecksComplete || !!dialogError.error?.blockedReason"
        (click)="onFinish()"
      >
        Finish
      </button>
    </div>
  </div>
}
